import { Activity } from "lucide-react";
import {
  CurrentStateStatsParamsSchema,
  defaultCurrentStateStatsParams,
  type CurrentStateStatsParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { CurrentStateStatsWidget } from "./Component.js";

export const currentStateStatsDef: WidgetDef<CurrentStateStatsParams> = {
  kind: "currentStateStats",
  label: "Current-State Snapshot",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 352, h: 300 },
  defaultParams: defaultCurrentStateStatsParams,
  Component: CurrentStateStatsWidget,
  storage: "sql",
  schema: CurrentStateStatsParamsSchema,
  accent: "cyan",
  icon: Activity,
  subtitle: "Hard data on where the gap is right now",
  defaultRoster: false,
  category: "single",
  layout: { col: 0, row: 3, width: 352, height: 300 },
  renderFooter: (data) => ({
    left: `${data.stats.length} measure${data.stats.length === 1 ? "" : "s"}`,
    right: "Snapshot · today",
  }),
};

registerWidget(currentStateStatsDef);
